import { array } from "superstruct";

import PurchasedProductSchema from "./PurchasedProductSchema";

const PurchasedProductListResponseSchema = array(PurchasedProductSchema);
export default PurchasedProductListResponseSchema;
